var map = {
	"./1inch.png": 3685,
	"./PayPal - png 0.png": 2992,
	"./Subtract.png": 3178,
	"./aave.png": 2769,
	"./algorand.png": 1819,
	"./apecoin-ape.png": 3330,
	"./aptos.png": 5070,
	"./arbitrum.png": 3617,
	"./avalanche.png": 7405,
	"./axie-infinity.png": 8383,
	"./binance-usd.png": 8515,
	"./bitcoin-cash.png": 4682,
	"./bitcoin-ic 3.png": 3482,
	"./bitcoin-sv.png": 1358,
	"./bitcoin.png": 8537,
	"./bitdao.png": 503,
	"./bittorrent-new.png": 1809,
	"./bnb.png": 8822,
	"./cardano.png": 5009,
	"./casper.png": 1433,
	"./chainlink.png": 6955,
	"./chiliz.png": 5697,
	"./compound.png": 8141,
	"./conflux-network.png": 7198,
	"./cosmos.png": 7334,
	"./cronos.png": 7074,
	"./curve-dao-token.png": 8644,
	"./dash.png": 8831,
	"./decentraland.png": 9350,
	"./default.png": 4973,
	"./dogecoin.png": 9210,
	"./dydx.png": 1093,
	"./ecash.png": 8708,
	"./enjin-coin.png": 983,
	"./eos.png": 2878,
	"./ethereum-classic.png": 6563,
	"./ethereum.png": 184,
	"./ethf.png": 1234,
	"./fantom.png": 3006,
	"./filecoin.png": 2954,
	"./flow.png": 6900,
	"./frax-share.png": 5058,
	"./gala.png": 1356,
	"./gatetoken.png": 6262,
	"./gemini-dollar.png": 7774,
	"./gmx.png": 7944,
	"./hedera.png": 8351,
	"./huobi-token.png": 8876,
	"./immutable-x.png": 4657,
	"./injective.png": 9905,
	"./internet-computer.png": 7111,
	"./iota.png": 1429,
	"./kava.png": 8251,
	"./klaytn.png": 948,
	"./kucoin-token.png": 5672,
	"./lido-dao.png": 4762,
	"./litecoin.png": 3980,
	"./maker.png": 4518,
	"./mewc.png": 6496,
	"./mina.png": 636,
	"./monero.png": 333,
	"./multi-collateral-dai.png": 4097,
	"./multiversx-egld.png": 7344,
	"./near-protocol.png": 2622,
	"./neo.png": 6072,
	"./nexo.png": 3886,
	"./okb.png": 7442,
	"./optimism-ethereum.png": 2835,
	"./pancakeswap.png": 5086,
	"./pax-gold.png": 1922,
	"./paxos-standard.png": 6918,
	"./pepe.png": 513,
	"./polkadot-new.png": 3830,
	"./polygon.png": 6049,
	"./quant.png": 2498,
	"./render.png": 1131,
	"./rocket-pool.png": 7099,
	"./shiba-inu.png": 6463,
	"./solana.png": 4377,
	"./stacks.png": 3702,
	"./stellar.png": 1631,
	"./sui.png": 6960,
	"./synthetix.png": 1675,
	"./terra-luna.png": 5077,
	"./tether-gold.png": 5401,
	"./tether.png": 1549,
	"./tezos.png": 2366,
	"./the-graph.png": 4542,
	"./the-sandbox.png": 8183,
	"./theta-network.png": 5102,
	"./thorchain.png": 7627,
	"./toncoin.png": 947,
	"./tron.png": 692,
	"./trueusd.png": 9591,
	"./trust-wallet-token.png": 7270,
	"./uniswap.png": 4711,
	"./unus-sed-leo.png": 8131,
	"./usd-coin.png": 6474,
	"./usdd.png": 2529,
	"./vechain.png": 5159,
	"./wootrade.png": 5085,
	"./wrapped-bitcoin.png": 6613,
	"./xinfin.png": 342,
	"./xrp.png": 9836,
	"./zcash.png": 7914,
	"./zec.png": 8665,
	"./zilliqa.png": 1672
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4995;